
// 3.- este archivo maneja la lógica de cada pregunta individualmente
// también mandará la respuesta a la base de datos
// aquí se harán el envío de datos al servidor para actualizar o agregar una respuesta

import { useEffect, useState } from "react"
import { URL_BACKEND } from "../../api/url"
import Cookies from 'universal-cookie';
import { elToast } from "../../functions/alertas";
import { indicesPreguntasContestadasStore } from "../../stores/preguntasContestadasStore";
import { useNavigate } from "react-router-dom";


const usePreguntaExamen = (pk_pregunta, indice) => {

    // variables
    const cookies = new Cookies();
    const pk_aspirante = cookies.get('pk_aspirante')

    const navigator = useNavigate();

    
    const [respuestaSeleccionada, setRespuestaSeleccionada] = useState(null);


    const indicesPreguntasContestadas = indicesPreguntasContestadasStore(state => state.indicesPreguntasContestadas);
    const agregarIndicePregunta = indicesPreguntasContestadasStore(state => state.agregarIndice);



    // useEffects
    useEffect(() => {

        if ( respuestaSeleccionada === null ) {
            return
        }

        if ( pk_aspirante === undefined ) {
            // si no tiene cookies lo mandamos a la página principal
            alert("Para realizar el examen debes iniciar sesión.");
            window.location.href = "/"

        } else {
            
            let body = new FormData();
            body.append("funcion", "guardarPreguntaAspirante");
            body.append("fk_aspirante", pk_aspirante);
            body.append("fk_respuesta", respuestaSeleccionada);
            body.append("pk_pregunta", pk_pregunta);

            fetch( URL_BACKEND, {
            method: 'post',
            body
            })
            .then( r => r.json() )
            .then( d => {

                if ( d.codigo == 1 ) {
                    
                    elToast(d.mensaje);

                    if (indicesPreguntasContestadas.includes(indice) == false) {
                        agregarIndicePregunta(indice);
                    }
            
                } else if ( d.codigo == 2 ) { //la fecha vigente ha terminado

                    alert("La fecha vigente para realizar el examen ha terminado.\nSerás dirigido al menú principal.");

                    navigator('/examen/');
                    return;
                    //se redirige a /examen/ para que se guarde el estado de la materia

                } else {
                    //código 0
                    elToast( d.mensaje, 'error' )
                }

            })
            .catch(() => { elToast('Ocurrió un problema al guardar la pregunta, vuelve a intentarlo.', "error"); });
        }   

    }, [ respuestaSeleccionada ])
    
    // return
    return {
        respuestaSeleccionada,
        setRespuestaSeleccionada
    }

}

export default usePreguntaExamen
